import { render, staticRenderFns } from "./TestimonialMale.vue?vue&type=template&id=1991774d&scoped=true&"
import script from "./TestimonialMale.vue?vue&type=script&lang=js&"
export * from "./TestimonialMale.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialMale.vue?vue&type=style&index=0&id=1991774d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991774d",
  null
  
)

export default component.exports